import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FinalQuotes from '../FinalQuotes';
import UnderstandStreak from './UnderstandStreak';
import UnlockGift from './UnlockGift';
import EarnCoins from './EarnCoins';
import PracticeSessionPostCompletionFeedBackQuestion from '../PracticeSessionPostCompletionFeedBackQuestion';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

// ✅ Styled Components for consistent UI
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: white;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const PracticeSessionPostCompletion = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);

  // ✅ Function to progress through steps
  const showNextStep = (nextStep) => {
    setCurrentStep(nextStep);
  };

  return (
    <StyledContainer>
      {currentStep === 1 && <FinalQuotes onContinue={() => showNextStep(2)} />}
      {currentStep === 2 && <UnderstandStreak onContinue={() => showNextStep(3)} />}
      {currentStep === 3 && <UnlockGift onContinue={() => showNextStep(4)} />}
      {currentStep === 4 && <EarnCoins onContinue={() => showNextStep(5)} />}
      {currentStep === 5 && (
        <PracticeSessionPostCompletionFeedBackQuestion
          lessonId="0.3postpracticefeedback"
          topicId="0.1"
          onComplete={() => navigate('/course-landing')} // ✅ Navigate ONLY when the user finishes feedback
        />
      )}
    </StyledContainer>
  );
};

export default PracticeSessionPostCompletion;






// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import FinalQuotes from '../FinalQuotes';
// import UnderstandStreak from './UnderstandStreak';
// import UnlockGift from './UnlockGift';
// import EarnCoins from './EarnCoins';
// import PracticeSessionPostCompletionFeedBackQuestion from '../PracticeSessionPostCompletionFeedBackQuestion';
// import { Container } from 'react-bootstrap';
// import styled from 'styled-components';

// // ✅ Styled Components for consistent UI
// const StyledContainer = styled(Container)`
//   background-color: #232830;
//   color: white;
//   min-height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   padding: 20px;
// `;

// const PracticeSessionPostCompletion = () => {
//   const navigate = useNavigate();
//   const [currentStep, setCurrentStep] = useState(1);

//   // ✅ Function to progress through steps
//   const showNextStep = (nextStep) => {
//     setCurrentStep(nextStep);
//   };

//   // ✅ Handle completion and redirect to Course Landing
//   useEffect(() => {
//     if (currentStep === 6) {
//       setTimeout(() => navigate('/course-landing'), 2000); // Redirect after final quotes
//     }
//   }, [currentStep, navigate]);

//   return (
//     <StyledContainer>
//       {currentStep === 1 && <FinalQuotes onContinue={() => showNextStep(2)} />}
//       {currentStep === 2 && <UnderstandStreak onContinue={() => showNextStep(3)} />}
//       {currentStep === 3 && <UnlockGift onContinue={() => showNextStep(4)} />}
//       {currentStep === 4 && <EarnCoins onContinue={() => showNextStep(5)} />}
//       {currentStep === 5 && (
//         <PracticeSessionPostCompletionFeedBackQuestion
//           lessonId="0.3postpracticefeedback"
//           topicId="0.1"
//           onComplete={() => showNextStep(6)}
//         />
//       )}
//       {currentStep === 6 && <FinalQuotes onContinue={() => navigate('/course-landing')} />}
//     </StyledContainer>
//   );
// };

// export default PracticeSessionPostCompletion;
